import { render } from "./NewBudget.vue?vue&type=template&id=6874fba8"
import script from "./NewBudget.vue?vue&type=script&lang=js"
export * from "./NewBudget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__